<template>
    <div class="customizer">
        <div v-if="is_development()" :class="'settings ' + (show_panel ? 'showSettings' : '')">
            <div class="settings--wrapper">
                <div class="settings--toggle" @click="toggle_options()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                        <path d="M0 0h48v48h-48z" fill="none"/>
                        <path custom-fill-primary d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97l-.75-5.3c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3c-1.22.51-2.35 1.17-3.38 1.97l-4.98-2.01c-.45-.17-.97 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31c-.08.64-.14 1.29-.14 1.95s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3c1.22-.51 2.35-1.17 3.38-1.97l4.98 2.01c.45.17.97 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zm-14.86 5.05c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
                    </svg>
                </div>
                
                <div :class="'settings--panel ' + (this.show_picker ? 'show_picker' : '')">
                    <div class="picker">
                        <Sketch
                            v-model="model"
                            @input="(value) => { color_picked(value.hex) }"
                            :preset-colors="[]"
                        />
                    </div>

                    <div class="d-flex">
                      <vb-checkbox :vb_options="{ text: 'customize', value: customization_on }" @change="toggle_body_customized()" />
                      <b-button size="sm" variant="info" v-b-modal.modal-export @click="toggle_options()">EXPORT</b-button>
                    </div>

                    <b-modal id="modal-export" title="Esporta schema colori" size="md" hide-footer>
                        <div class="export-string">
                        <p><pre>{{colors}}</pre></p>
                        </div>
                    </b-modal>

                    <div class="colors">
                        <div class="colors--tab">
                            <ul>
                                <li @click="toggle_picker('primary', primary)">
                                    <span class="title">primary</span>
                                    <span class="preview" :style="'background-color: var(--primary)'"></span>
                                </li>
                                <li @click="toggle_picker('secondary', secondary)">
                                    <span class="title">secondary</span>
                                    <span class="preview" :style="'background-color: var(--secondary)'"></span>
                                </li>
                                <li @click="toggle_picker('info', info)">
                                    <span class="title">info</span>
                                    <span class="preview" :style="'background-color: var(--info)'"></span>
                                </li>
                            </ul>
                        </div>
                        <div class="colors--tab">
                            <ul>
                                <li @click="toggle_picker('extra1', extra1)">
                                    <span class="title">extra1</span>
                                    <span class="preview" :style="'background-color: var(--extra1)'"></span>
                                </li>
                                <li @click="toggle_picker('extra2', extra2)">
                                    <span class="title">extra2</span>
                                    <span class="preview" :style="'background-color: var(--extra2)'"></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="customization_on && get_config() !== undefined">
          <v-style type="text/css" v-for="color in color_schema" v-bind:key="color">
            :root { --{{color}}: {{vb[color]}}; }
          </v-style>

          <div class="poweredBy" v-if="poweredBy_on">
            <div v-if="get_config('guiSettings.customizations.poweredByCaption')" class="poweredBy__caption">
              {{ get_config('guiSettings.customizations.poweredByCaption') }}
            </div>
            <div v-if="get_config('guiSettings.customizations.poweredByLogo')" class="poweredBy__logo">
              <img :src="get_config('guiSettings.customizations.poweredByLogo')" />
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  import { Sketch } from 'vue-color'

    export default {
        name: 'customize',
        components:
        {
          Sketch,
        },
        data() {
          return {
            vb: this,
            color_schema: ['primary', 'secondary', 'info', 'extra1', 'extra2'],
            show_panel: false,
            colors: {},
            customization_on: true,
            model: '',
            show_picker: false,
            open_picker_color: '',
            primary: this.sass('primary'),
            secondary: this.sass('secondary'),
            info: this.sass('info'),
            extra1: '',
            extra2: '',
            poweredBy_on: false,
          }
        },
        methods:
        {
          toggle_options() {
              this.show_panel = !this.show_panel
          },
          toggle_picker(name, color) {
            if(!this.customization_on) return
            this.open_picker_color = name
            this.model = color
            if(this.show_picker) return
            this.show_picker = true
          },
          color_picked(color) {
            this[this.open_picker_color] = color
            this.colors[this.open_picker_color] = color
          },
          toggle_body_customized(){
              (document.body.classList).toggle('customized')
              this.customization_on = !this.customization_on
              if(!this.customization_on) this.show_picker = false
              this.$emit('customize')
          },
        },
        mounted() {
          const config = this.get_config()
          const customizations = config.guiSettings.customizations.colors || null

          if (!customizations) return

          this.customization_on = true
          document.body.classList.add('customized')

          let colors = {},
            default_colors = {}

          Object.keys(customizations).forEach(c => {
            this[c] = customizations[c]
            colors[c] = default_colors[c] = customizations[c]
          })

          this.colors = colors

          if (this.customization_on) this.poweredBy_on = customizations.poweredByLogo || customizations.poweredByCaption
        }
    }
</script>

<style lang="scss" scoped>
  $toggle-size: 40px;
  $picker-size: 260px;
  $background: #fff;
  $border: #ccc;
  $border-dark: #ccc;

  .settings {
      color:#313131;
    position:fixed;
    top:40%;
    right:0;
    z-index: 999999;
    transform:translateX(calc(100% - #{$toggle-size} - 1rem));
    transition: all 0.5s ease-in-out;

    &.showSettings
    {
        transform:translateX(0px);
    }

    button
    {
        text-transform: uppercase;
        margin:0 auto;
    }

    &--wrapper
    {
        display: flex;
    }

    &--toggle
    {
        background: $background;
        width:$toggle-size;
        height:$toggle-size;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
        cursor:pointer;
        border-left:1px solid $border-dark;
        border-top:1px solid $border-dark;
        border-bottom:1px solid $border-dark;
        margin-right:-1px;
        margin-top:-1px;
        position:relative;
        z-index: 1;
        padding:6px;
    }

    &--panel
    {
        padding:20px;
        min-width:220px;
        //min-height:200px;
        background: $background;
        position:relative;
        transition: all 0.75s ease-in-out;
        //border:1px solid $border-dark;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        box-shadow: 0 0 0 1px rgb(0 0 0 / 15%), 0 8px 16px rgb(0 0 0 / 15%);

        ul {
          padding-left: 0;
          margin-right: 1rem;
        }

        &.show_picker
        {
            margin-right: $picker-size;
        }
        .picker
        {
            position:absolute;
            top:0;
            right:0;
            transform: translateX($picker-size);
        }
        .colors
        {
            display: flex;
            margin-top:20px;
            strong
            {
                display: block;
                font-size: 12px;
                margin-bottom: 12px;
            }
            &--tab
            {
                &:not(:last-child)
                {
                    margin-right:20px;
                }
            }
        }
        ul
        {
            flex:1;
            //min-width:120px;
        }
        li
        {
            line-height: 1;
            display:flex;
            align-items: center;
            margin-bottom: 12px;
            padding: 6px 6px 6px 10px;
            border: 1px solid $border;
            border-radius: 5px;
            &:first-child
            {
            }
            &:last-child
            {
            }
            cursor: pointer;
            .title
            {
                flex:1;
                white-space: nowrap;
                font-size: 14px;
                min-width: 100px;
            }
            .preview
            {
                width:20px;
                height:20px;
                border: 1px solid $border;
            }
        }
    }
  }

  .poweredBy {
    position: fixed;
    top: 85vh;
    left: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 12px 0 rgba(0,0,0,0.1), 0 1px 2px 0 rgba(0,0,0,0.2);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    transform: rotate(-90deg);
    transform-origin: top left;
    overflow: hidden;
    padding: 8px;
    &__caption {
      font-size: 12px;
      letter-spacing: 0.035em;
      margin-right: 12px;
      margin-left: 4px;
    }
    &__logo {
      img {
        object-fit: contain;
        max-width: 100px;
        max-height: 28px;
      }
    }
  }
</style>

<style lang="scss">
    .export-string {
      display: flex;
      align-items: center;
      justify-content:center;
      padding:20px;
    }
</style>